import * as types from "./actionTypes";
import axios from "axios";
import map from "../map";

export const getControls = () => dispatch => {
  axios
    .get(process.env.REACT_APP_API_URL + "/map/controls")
    .then(({ data }) => {
      const controls = {};
      controls.response = data.response;
      // controls.schedule = data.response.schedule.controls;
      // controls.disabledAccess = data.response.disabledAccess.controls;
      // controls.libraryType = data.response.libraryType.controls;
      // controls.resources = data.response.resources.controls;
      // controls.copy = data.response.copy.controls;
      // controls.children = data.response.children.controls;
      // controls.services = data.response.services.controls;
      // controls.languages = data.response.languages.controls;
      // controls.single_library_card = data.response.single_library_card.controls;
      // controls.paid_services_single =
      //   data.response.paid_services_single.controls;
      // controls.paid_services_multi = data.response.paid_services_multi.controls;

      return dispatch({
        type: types.CONTROLS_GET,
        controls: controls
      });
    });
};

export const checkControl = control => dispatch => {
  return Promise.resolve()
    .then(() =>
      dispatch({
        type: types.CONTROL_TOGGLE,
        control
      })
    )
    .then(() => dispatch(map.actions.getLibraries()));
};



// WEBPACK FOOTER //
// ./src/modules/controls/actions.js